import { Component, OnInit,Output,Input, EventEmitter, SimpleChanges } from '@angular/core';
import { GetDataService } from '../services/get-data.service';

import { langEN, langSK } from '../variables';
import { Languages } from '../languages';



import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-input-form',
  templateUrl: './input-form.component.html',
  styleUrls: ['./input-form.component.css']
})
export class InputFormComponent implements OnInit {
  shipmentNumber: string = ''
  wrongInput: boolean = false
  params: ParamMap;

  lang: Languages;

  @Input() langToChild: Languages;

  @Output() newItemEvent = new EventEmitter<string>();

  @Output() langToParent = new EventEmitter<Languages>();


  constructor(private getDataService: GetDataService,
              private activatedRoute: ActivatedRoute
              ) { }

  ngOnChanges(changes:SimpleChanges ) {

    this.lang = this.langToChild

  }

  ngOnInit() {
    var a: string

    this.lang = langSK

    // aby precitalo ak niekto zada napriamo get query /?parcelId=21032600003
    this.activatedRoute.queryParams
    .pipe()
    .subscribe(params => {
      this.shipmentNumber = params.parcelId;

      if (params.lang =='en') {
        this.lang = langEN
      } else {
        this.lang = langSK
      }
      // console.log(params.lang);
      
      // if (this.getDataService.checkIfNumber(a)) {
      //   this.wrongInput = this.getDataService.checkIfNumber(a)
      // } else {    
      //   this.getData(a)
      // }
    });
   }

  searchItem(value: string) {

    this.wrongInput = false
    if(value) {
      this.jeToCislo(value);
      if (!this.wrongInput) {
        value = value.replace(/\s+/g, '')
        this.newItemEvent.emit(value);
        this.langToParent.emit(this.lang)
      } else {
        // console.log('zly format cisla');
        
        this.newItemEvent.emit('');
        this.langToParent.emit(this.lang)
      }
    }
    
    // console.log('searchItem ' + value);
  }

  jeToCislo (value: string) {
    if (this.getDataService.checkIfNumber(value)) {
      this.wrongInput = false
    } else {
      this.wrongInput = true
    }
  }





}